import assign from 'lodash/assign';
/**
 * @desc  AccessService class.
 * @ngInject
 */
export default class AccessService {
  /**
   * Constructor of the class.
   *
   * @param {$rootScope} $rootScope
   * @param {$q} $q
   * @param {$log}  $log
   * @param {$http} $http
   */
  constructor(
    $rootScope, $q, $log, $http
  ) {
    this.$rootScope = $rootScope;
    this.$q = $q;
    this.$log = $log;
    this.$http = $http;

    this.state = {};

    const defaultState = {
      data: {},
      fetched: false,
      lastUpdate: null
    };

    assign(this.state, defaultState);

    this.$rootScope.$on('scr.select', () => {
      this.setState(defaultState);
    });
  }

  getState() {
    return this.state;
  }

  setState(newState) {
    const state = Object.assign(this.state, newState);
    return state;
  }

  getAll(schoolCommonRoomId, fromServer = false) {
    if (this.state.fetched && !fromServer) {
      return this.$q.resolve(this.getState().data);
    }

    if (angular.isUndefined(schoolCommonRoomId)) {
      schoolCommonRoomId = this.$rootScope.me.schoolCommonRoomId;
    }

    return this.$http({
      method: 'GET',
      url: `/SCR/schoolCommonRoom/${schoolCommonRoomId}/generalAccess`
    }).then(result => {
      const newState = {
        data: result.data,
        fetched: true,
        lastUpdate: Date.now()
      };
      this.setState(newState);
      return this.$q.resolve(this.getState().data);
    }, err => {
      this.$log.error(err);
      return this.$q.reject(err);
    });
  }

  get(employeeId) {
    const accessObj = {};
    if (this.state.fetched) {
      const employee = this.state.data.employees.filter(employee => Number(employee.id) === employeeId);
      if (employee.length > 0) {
        employee[0].globalAccessEntries.map(access => {
          accessObj[access.resourceName] = access.hasAccess;
          return access;
        });
      }

      return this.$q.resolve(accessObj);
    }

    return this.getAll().then(result => {
      const employee = result.employees.filter(employee => Number(employee.id) === employeeId);
      if (employee.length > 0) {
        employee[0].globalAccessEntries.map(access => {
          accessObj[access.resourceName] = access.hasAccess;
          return access;
        });
      }

      return accessObj;
    });
  }

  add(employeeId, data) {
    return this.$http({
      method: 'POST',
      url: '/SCR/generalAccess/' + employeeId,
      data
    }).then(result => {
      const employees = this.getState().data.employees.map(employee => {
        if (Number(employee.id) === employeeId) {
          employee.globalAccessEntries = employee.globalAccessEntries.map(access => {
            if (access.resourceId === data.generalAccess.resourceId) {
              access.hasAccess = true;
              access.accessEntryId = result.data.id;
            }

            return access;
          });
        }

        return employee;
      });
      const newState = {
        data: {employees},
        fetched: true,
        lastUpdate: Date.now()
      };
      this.setState(newState);
      return result.data;
    }, err => this.$q.reject(err));
  }

  getModuleName(accessId) {
    let moduleAccessName = '';
    switch (accessId) {
      case 1:
        moduleAccessName = 'attendance';
        break;
      default:
        moduleAccessName = '';
    }

    return moduleAccessName;
  }

  getEmployeeAccess(accessArray) {
    const accessObj = {};
    if (accessArray && accessArray.length > 0) {
      accessArray.map(item => {
        accessObj[this.getModuleName(item)] = true;
        return item;
      });
    }

    return accessObj;
  }

  delete(accessId) {
    return this.$http({
      method: 'DELETE',
      url: `/SCR/generalAccess/${accessId}`
    }).then(result => result, err => this.$q.reject(err));
  }
}
